<template>
    <div>
        <div class="flex flex-col min-h-0 h-full p-6 pt-5 | 2xl:p-8 2xl:pt-8">
            <page-header
                :subtitle="`${$t('imports.result.import')} #${fetchedImport.id}`"
                :title="$t('global.mainNav.imports')"
                :to="{ name: 'imports' }"
            />

            <content-box :loading="loading">
                <template #header v-if="fetchedImport.id">
                    <div class="w-full flex flex-col justify-center items-center p-4 space-y-2">
                        <h3 class="text-xl">
                            {{ `${$t('imports.result.import')} #${fetchedImport.id}` }}
                        </h3>

                        <div class="flex items-center space-x-6">
                            <div class="flex items-center break-words">
                                <nio-icon class="mr-2" name="regular/tags" />
                                {{ $t(`imports.result.types.${fetchedImport.type}`) }}
                            </div>

                            <div class="flex items-center break-words">
                                <nio-icon class="mr-2" name="regular/calendar-3" />
                                {{ formatDateTime(fetchedImport.created_at) }}
                            </div>

                            <div class="flex items-center break-words">
                                <nio-icon class="mr-2" name="regular/common-file-text" />
                                {{ fetchedImport.file_name }}
                            </div>
                        </div>
                    </div>
                </template>
                <template #body>
                    <nio-table
                        :columns="columns"
                        :rows="fetchedImport.appointments"
                        ref="body"
                    >
                        <template #no-results>
                            <figure class="mb-6 text-3xl select-none">
                                ¯\_(ツ)_/¯
                            </figure>
                            <p class="text-xl">
                                {{ $t('global.general.noResults') }}
                            </p>
                        </template>

                        <template v-slot:[`column-${column.name}`]="{ row: appointment, index }" v-for="column in columns">
                            <import-result-list-item
                                :appointment="appointment"
                                :column="column.name"
                                :index="index"
                                :truncate="column.truncate"
                                :key="column.name"
                            />
                        </template>
                    </nio-table>
                </template>
            </content-box>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import ContentBox from '@/components/ContentBox.vue';
    import ImportResultListItem from '@/views/Appointments/ImportResultListItem.vue';
    import PageHeader from '@/components/PageHeader.vue';

    export default {
        components: {
            ContentBox,
            ImportResultListItem,
            PageHeader,
        },

        data() {
            return {
                loading: true,
                fetchedImport: {
                    id: 0,
                    appointments: [],
                },
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            columns() {
                return [
                    {
                        name: 'number',
                        icon: 'regular/hash',
                        className: 'w-12',
                        align: 'center',
                    },
                    {
                        name: 'name',
                        label: this.$t('imports.preview.name'),
                        icon: 'regular/single-neutral',
                        className: 'flex-3',
                    },
                    {
                        name: 'phone',
                        label: this.$t('imports.preview.phone'),
                        icon: 'regular/phone',
                        className: 'flex-2',
                    },
                    {
                        name: 'date',
                        label: this.$t('imports.preview.date'),
                        icon: 'regular/calendar-3',
                        className: 'flex-2',
                    },
                    {
                        name: 'status',
                        label: this.$t('imports.result.status'),
                        icon: 'regular/graph-stats-circle',
                        className: 'flex-2',
                    },
                ];
            },
        },

        methods: {
            goBack() {
                this.$router.push({ name: 'imports' });
            },
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                // Reset values
                vm.loading = true;

                vm.$axios.get(`imports/${vm.$route.params.id}/results`)
                    .then(response => {
                        vm.fetchedImport = response.data.data;

                        // Redirect if import does not belong to the current account
                        if (vm.authUser.account.id != vm.fetchedImport.account_id) {
                            vm.$router.replace({ name: 'imports' });
                        }

                        vm.loading = false;
                    })
                    .catch(() => {
                        vm.loading = false;

                        // Import deleted, redirect
                        if (error.response.status == 404) {
                            vm.$router.replace({ name: 'imports' });
                        }
                    });
            });
        },
    };
</script>
